module.exports = __webpack_public_path__ + "media/images/athletes/92-83a0e63fd10a1a109f2e11788dd78936.png";